import { useState, useEffect } from "react";

const useSlideShow = (imageUrls: string[], intervalDelay: number): number => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    if (imageUrls.length <= 1) return undefined;

    const interval = setInterval(() => {
      setActiveImageIndex((current) => (current + 1) % imageUrls.length);
    }, intervalDelay);

    return () => clearInterval(interval);
  }, [imageUrls, intervalDelay]);

  return activeImageIndex;
};

export default useSlideShow;
